import React from 'react';

export default function LoadingPage() {
  return (
    <div className="fixed top-0 left-0 w-full h-full overflow-none bg-white grid grid-cols-1 grid-rows-1 items-center justify-center text-center">
      <svg width="40px" height="40px" viewBox="0 0 50 50" xmlSpace="preserve" className="mx-auto">
        {/* tslint:disable-next-line:max-line-length */}
        <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
          <animateTransform
            attributeType="xml"
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="0.6s"
            repeatCount="indefinite"
          />
        </path>
      </svg>
    </div>
  );
}
